
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import {
  CookiesLoadingIndicator,
  Spinner,
} from '@devsisters/ui-common';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"loading-indicator"}}>{`loading-indicator`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"cookiesloadingindicator"}}>{`CookiesLoadingIndicator`}</MDXTag>
<MDXTag name="p" components={components}>{`동그란 쿠키얼굴이 번갈아가며 등장하는 로딩인디케이터용 애니메이션입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { CookiesLoadingIndicator } from '@devsisters/ui-common';
// 또는 import { CookiesLoadingIndicator } from '@devsisters/ui/lib/common/loading-indicator';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<CookiesLoadingIndicator style={{ fontSize: \'110px\' }} />'} __scope={{props: this ? this.props : props,CookiesLoadingIndicator,Spinner}}>
  <CookiesLoadingIndicator style={{ fontSize: '110px' }}/>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"spinner"}}>{`Spinner`}</MDXTag>
<MDXTag name="p" components={components}>{`동그란 선이 돌아가면서 줄어들었다 늘어났다를 반복하는 로딩인디케이터용 애니메이션입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { Spinner } from '@devsisters/ui-common';
// 또는 import { Spinner } from '@devsisters/ui/lib/common/loading-indicator';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터-1"}}>{`놀이터`}</MDXTag>
<Playground __position={1} __code={'<Spinner style={{ fontSize: \'50px\', color: \'red\' }} lineCap=\"butt\" />\n<Spinner style={{ fontSize: \'60px\', color: \'green\' }} lineCap=\"round\" />\n<Spinner style={{ fontSize: \'70px\', color: \'blue\' }} lineCap=\"square\" />'} __scope={{props: this ? this.props : props,CookiesLoadingIndicator,Spinner}}>
  <Spinner style={{ fontSize: '50px', color: 'red' }} lineCap='butt'/>
  <Spinner style={{ fontSize: '60px', color: 'green' }} lineCap='round'/>
  <Spinner style={{ fontSize: '70px', color: 'blue' }} lineCap='square'/>
</Playground>
           </MDXTag>
  }
}
  